import Stripe from "@/modules/stripe";

export const createToken = data => {
  return new Promise((resolve, reject) => {
    Stripe.card.createToken(data, (status, stripeResp) => {
      if (stripeResp.error) {
        return reject(stripeResp);
      }

      return resolve(stripeResp);
    });
  });
};
